import { call, put, fork, select } from 'redux-saga/effects'
import firebase from '../config/firebase'

import DeliveryFeeOfferActions from '../reducers/deliveryFeeOfferReducer'

export function* getDeliveryFeeOffers() {
  try {
    const { region } = yield select(state => state.auth.data)
    yield put(DeliveryFeeOfferActions.setLoading(true))

    const dbRef = firebase
      .firestore()
      .collection('delivery_fee_offers')
      .where('region', '==', region)

    const snapShot = yield call([dbRef, dbRef.get])
    const deliveryFeeOffers = {}

    snapShot.forEach(doc => {
      deliveryFeeOffers[doc.id] = { ...doc.data(), key: doc.id }
    })

    yield put(DeliveryFeeOfferActions.setDeliveryFeeOffers(deliveryFeeOffers))
    yield put(DeliveryFeeOfferActions.setLoading(false))
  } catch (error) {
    yield put(DeliveryFeeOfferActions.setLoading(false))
  }
}

export function* deleteDeliveryFeeOffer({ deliveryFeeOffer }) {
  try {
    const { merchant, branch } = deliveryFeeOffer

    const dbRef = firebase
      .firestore()
      .collection('delivery_fee_offers')
      .doc(deliveryFeeOffer.key)

    const databaseRef = firebase.database().ref()
    const updates = {}

    updates[`restaurants/${merchant}/branches/${branch}/delivery_discount_offer`] = null

    yield call([databaseRef, databaseRef.update], updates)
    yield fork([dbRef, dbRef.delete])
  } catch (err) {
    alert(err)
  }
}

export function* saveDeliveryFeeOffer({ data, deliveryFeeOffer }) {
  const dbRef = firebase.firestore().collection('delivery_fee_offers')
  const databaseRef = firebase.database().ref()

  const deliveryFeeOfferDoc = deliveryFeeOffer ? dbRef.doc(deliveryFeeOffer.key) : dbRef.doc()
  const { id: deliveryFeeOfferKey } = deliveryFeeOfferDoc

  const deliveryDiscount = data.active ? data.delivery_discount : null

  const updates = {}
  updates[`restaurants/${data.merchant}/branches/${data.branch}/delivery_discount_offer`] = deliveryDiscount

  try {
    if (deliveryFeeOffer) {
      yield call([deliveryFeeOfferDoc, deliveryFeeOfferDoc.update], data)
    } else {
      yield call([deliveryFeeOfferDoc, deliveryFeeOfferDoc.set], data)
    }

    yield fork([databaseRef, databaseRef.update], updates)
    yield put(
      DeliveryFeeOfferActions.setDeliveryFeeOffer(deliveryFeeOfferKey, { ...data, key: deliveryFeeOfferKey })
    )
  } catch (err) {
    alert(err)
  }
}



// WEBPACK FOOTER //
// ./src/sagas/deliveryFeeOfferSaga.js